import Swiper from "swiper";
import breakpointChecker from "../utils/breakpointChecker";
import swiperA11y from "../utils/swiperA11y";

const fundDetailTabInit = function () {
  (function ($) {
    window.Sharer.init({
      callbackAPI: `fundDetailTabInit`,
    });

    $('#fundDetailTab a[href^="#"]').click(function () {
      console.log($.attr(this, "href"));
      var currentY = $(window).scrollTop();
      var tabHeight = $(".fundDetailTab").innerHeight();
      var target = $.attr(this, "href");
      var clickedTab = $($.attr(this, "href")).offset().top;
      var topHeight;

      //scroll down
      if (clickedTab > currentY) {
        var headerHeight = 0;
        if ($(window).width() >= 992) {
          headerHeight = 75 - 20;
        } else {
          $("header").css("opacity", "0");
        }
        if (!$(".fundDetailTab").hasClass("fixed--top")) {
          tabHeight = tabHeight * 2;
        }

        topHeight = headerHeight + tabHeight - 5;
      } else {
        //scroll up
        var headerHeight = 90 - 5;
        if ($(window).width() >= 992) {
          headerHeight = 125 - 15;
        } else {
          $("header").css("opacity", "1");
        }
        topHeight = headerHeight + tabHeight;
      }
      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - topHeight,
        },
        500
      );

      target.focus(); // Setting focus
      if (target.is(":focus")) {
        // Checking if the target was focused
        return false;
      } else {
        target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
        target.focus(); // Setting focus
      }

      return false;
    });

    var lastY = $(window).scrollTop();
    $(window).on("scroll", function () {
      var currentY = $(window).scrollTop();
      var headerHeight = $(".header").innerHeight();
      var fundDetailTabY = $("#fundDetailTab")[0].offsetTop;
      var triggerY = fundDetailTabY - 50;
      if (triggerY < currentY + headerHeight) {
        $(".fundDetailTab, .fundDetailTab__controls").addClass("fixed--top");
        if (currentY > lastY) {
          $(".fundDetailTab").removeClass("scrolling--up");
        } else {
          $(".fundDetailTab").addClass("scrolling--up");
        }
      } else {
        $(".fundDetailTab, .fundDetailTab__controls").removeClass("fixed--top");
        $(".fundDetailTab").removeClass("scrolling--up");
      }
      lastY = currentY;
      onScroll();
    });

    let swiper;
    const enableSwiper = function () {
      console.log("enableSwiper");
      swiper = new Swiper(".fundDetailTab .swiper-container", {
        // Optional parameters
        // If we need pagination
        autoplay: false,
        loop: false,
        grabCursor: true,
        watchSlidesVisibility: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            autoHeight: true,
            slidesPerView: "auto",
            spaceBetween: 0,
          },
          // when window width is >= 992px
          992: {
            autoHeight: true,
            slidesPerView: "auto",
            spaceBetween: 0,
          },
          1336: {
            autoHeight: true,
            slidesPerView: 5,
            spaceBetween: 0,
          },
        },
        navigation: {
          nextEl: ".fundDetailTab__controls .swiper-button-next",
          prevEl: ".fundDetailTab__controls .swiper-button-prev",
        },
        init: false,
        on: {
          init: function () {
            swiperA11y.toggleAriaHidden(swiper, false);
          },
          resize: function (s) {
            // $('#fundDetailTab__slider').attr('style', '')
          },
        },
        observer: true,
        observeParents: true,
      });
      swiper.init();

      swiper.on("transitionStart", function () {
        swiperA11y.toggleAriaHidden(swiper, false);
      });
    };
    const BPChecker = new breakpointChecker({
      mediaQuery: "(min-width:1336px)",
      onMatch: function () {
        if (swiper !== undefined) swiper.destroy(true, true);
        $(".fundDetailTab__slider").addClass("fundDetailTab__slider--static");
        $(".fundDetailTab__slide")
          .removeAttr("aria-hidden")
          .find("a, button")
          .removeAttr("tabindex");
      },
      onDifferent: enableSwiper,
    });

    //syncHeight('.fundDetailTab')
    //syncHeight('.fundDetailTab')
    enableSwiper();

    function syncHeight(el) {
      let height = 0;
      $(el).each(function () {
        height = Math.max($(this).outerHeight(), height);
      });

      $(el).innerHeight(function () {
        return $(window).width() >= 992 ? height : "auto";
      });
    }

    function onScroll() {
      var scrollPos = $(document).scrollTop();
      $(".fundDetailTab__slider .swiper-wrapper > a").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        var headerHeight =
          $(".header").innerHeight() +
          $(".fundDetailTab__container ").innerHeight();

        if (
          refElement.position().top <= scrollPos + headerHeight &&
          refElement.position().top + refElement.height() + headerHeight >
            scrollPos
        ) {
          $(".fundDetailTab__slider .swiper-wrapper >a.active").removeClass(
            "active"
          );
          currLink.addClass("active");
          //- const list = [...document.querySelectorAll('.fundDetailTab__slide')];
          const list = Array.prototype.slice.call(
            document.querySelectorAll(".fundDetailTab__slide")
          );
          if (list) {
            const active = document.querySelector(
              ".fundDetailTab__slide.active"
            );
            //console.log(swiper)
            //console.log(swiper.activeIndex)
            if (list.indexOf(active) != swiper.activeIndex) {
              if (swiper) {
                swiper.slideTo(list.indexOf(active));
              }
            }
          }
        } else {
          currLink.removeClass("active");
        }
      });
      // if ($("#why").position().top > scrollPos) {
      //   $('.fundDetailTab__slider .swiper-wrapper a[href="#why"]').addClass(
      //     "active"
      //   );
      // }
    }
  })(window.hsvmJQuery);
};
export default fundDetailTabInit;
